import ZkErrorPage from './src/main'
ZkErrorPage.install = function (Vue) {
  Vue.component(ZkErrorPage.name, ZkErrorPage)
}
export default ZkErrorPage



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/error/index.js